<template>
  <v-container fluid grid-list-lg>
    <Create :createDialog="createDialog" :subscription="selectedSubscription" @close="createDialog = false"
      @submit="getList" :donor="DonorId"></Create>
    <v-card :loading="loading" outlined>
      <v-toolbar dense flat color="grey lighten-3">
        <v-app-bar-nav-icon v-if="!DonorId" @click="$router.go(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>

        <v-toolbar-title>Template </v-toolbar-title>
        <v-spacer> </v-spacer>
        <v-layout row wrap justify-end>
          <v-flex shrink v-if="toggleStatus === 'show'">
            <v-btn-toggle small rounded v-model="toggleChange" >
              <v-btn small>
                <span class="hidden-sm-and-down">Donor</span>
                <v-icon small right>mdi-hand-coin-outline</v-icon>
              </v-btn>
              <v-btn small>
                <span class="hidden-sm-and-down">Parents</span>
                <v-icon small right>mdi-account-outline</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          <v-flex shrink>
            <v-btn v-if="checkRightStatus(61)" @click="add" outlined small rounded> New
            </v-btn>
          </v-flex>
          <v-flex shrink>
            <v-checkbox label="Show Expire" v-model="showExpire"></v-checkbox>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <v-card-text class="mb-0 pb-0">
        <!-- <v-btn color="success" @click="runTest">run test</v-btn> -->
        <v-row>
          <v-col cols="12" md="3" sm="12">
            <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search" single-line
              hide-details clearable>
            </v-text-field>
          </v-col>
          <!-- <v-spacer> </v-spacer>
          <v-flex shrink>
            <v-checkbox class="mr-2" v-model="toggleChange" value="Donors" label="Show Donors Only"></v-checkbox>
          </v-flex>
          <v-flex shrink>
            <v-checkbox class="mr-2" label="Show Customers Only" v-model="toggleChange" value="Customers"></v-checkbox>
          </v-flex> -->
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-data-table :headers="headers" :items="Subscriptions" :search="search" :sort-desc="sortDesc"
          :loading="loading" :sort-by="sortBy" :page.sync="page" :items-per-page="itemsPerPage">
          <template v-slot:item="{ item }">
            <tr class="pointer" >
              <!-- <td class="text-left">
                {{ item.id }}
              </td> -->
              <!-- <td class="text-left">
                {{ item.createdAt | moment("MM/DD/YYYY") }}
              </td> -->
              <!-- <td class="text-left">
                {{ item.startingDate | moment("MM/DD/YYYY") }}
              </td> -->
              <!-- <td class="text-left" >
                {{ item.localId }}
                <v-chip v-if="item.due === 0" small color="red" text-color="white" class="ml-2 font-weight-bold" label>
                  Paid
                </v-chip>
              </td> -->
              <td class="text-left" @click="viewProfileNewTab(item)">
                <v-icon color="green" v-if="item.Customer">mdi-account-outline</v-icon>
                <v-icon color="red" v-if="item.Donor">mdi-hand-coin-outline</v-icon>
                <span class="text-decoration-underline blue--text">{{ item.name}}</span>
                <span class="ml-2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-chip small label v-on="on" color="grey lighten-4">
                        Starts {{ item.startingDate | moment("MMM DD") }}
                        <v-icon small right>
                          mdi-clock-time-eight-outline
                        </v-icon>
                      </v-chip>
                    </template>
                    <span>Carted At {{ item.createdAt | moment("MM/DD/YYYY") }}</span>
                  </v-tooltip>
                </span>
              </td>

              <td class="text-left" @click="viewSubscription(item)">
                <span v-if="item.Customer" class="ml-1">
                  <v-tooltip bottom v-if="item.Customer.payCompassId">
                    <template v-slot:activator="{ on, attrs }">
                      <v-avatar size="10" color="yellow" v-bind="attrs" v-on="on" />
                    </template>
                    <span>Set for online payment</span>
                  </v-tooltip>
                </span>
                <span v-else-if="item.Donor" class="ml-1">
                  <v-tooltip bottom v-if="item.Donor.payCompassId">
                    <template v-slot:activator="{ on, attrs }">
                      <v-avatar size="10" color="yellow" v-bind="attrs" v-on="on" />
                    </template>
                    <span>Set for online payment</span>
                  </v-tooltip>
                </span>
                <span v-if="item.cashCollect">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-avatar size="10" color="green" v-bind="attrs" v-on="on" />
                    </template>
                    <span>Will Collect In Cash</span>
                  </v-tooltip>
                </span>
              </td>

              <td class="text-left" @click="viewSubscription(item)">
                <div v-if="isRecurringExpired(item)">{{ formattedNextInvoiceDate(item.nextInvoiceDate) }}</div>
                <div v-else><v-chip small label color="red darken-3" text-color="white">
                    Expired
                    <v-icon small right>
                      mdi-lock-clock
                    </v-icon>
                  </v-chip></div>

              </td>
              <td class="text-left" @click="viewSubscription(item)">
                <div v-if="item.endDate">{{ item.endDate | moment("MM/DD/YYYY") }}</div>
                <span v-if="item.recurringForever">
                  <v-chip small label color="light-blue lighten-5" text-color="light-blue darken-4">

                    Forever
                    <v-icon small right>
                      mdi-all-inclusive
                    </v-icon>
                  </v-chip>
                </span>
              </td>
              <td class="text-right"  @click="viewSubscription(item)">
                {{ item.total | currency }}
              </td>
              <!-- <td v-else class="text-right" @click="viewSubscription(item)">Base on student count</td> -->
              <!-- <td class="text-right" >
                {{ item.payment | currency }}
              </td>
              <td class="text-right" >
                {{ item.due | currency }}
              </td> -->
              <td class="justify-end align-center text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="menu-button">
                    <v-list-item v-if="!DonorId && !CustomerId" @click="viewProfile(item)">
                      <v-list-item-title>Profile</v-list-item-title>
                    </v-list-item>
                    <v-divider v-if="!DonorId && !CustomerId"></v-divider>
                    <v-list-item @click="viewSubscription(item)">
                      <v-list-item-title>View Subscription</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="collectedPayment(item)">
                      <v-list-item-title>Collect Payment Information</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item v-if="checkRightStatus(63)" @click="editSubscription(item)">
                      <v-list-item-title>Edit </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="checkRightStatus(64)" @click="deleteSubscription(item)">
                      <v-list-item-title>Delete </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="isRecurringExpired(item)" @click="createInvoice(item)">
                      <v-list-item-title>Create Invoice</v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="isRecurringExpired(item)" @click="createInvoiceAndCollect(item)">
                      <v-list-item-title>Create Invoice & Collect</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
              <!-- <td>
                <v-btn @click="deleteSubscription(item)" icon>
                  <v-icon>delete</v-icon>
                </v-btn>
                <v-btn v-if="item.Donor" @click="collectedPayment(item)" icon>
                  <v-icon>mdi-account-credit-card-outline</v-icon>
                </v-btn>
              </td> -->

            </tr>
          </template>

          <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
            results.</v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="loadingDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-container>
          <div class="mb-3">Please stand by</div>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import subscriptionService from "../service";
const Create = () => import("@/modules/Donors/PaymentInfoCollect/Create.vue");
// import ShareLink from "@/components/ShareLink";
// const DateTimePicker = () => import("@/components/DateTimePicker");
// import paymentService from "@/modules/Payment/service.js";
import Hashids from "hashids";
const hashids = new Hashids();
import moment from 'moment';
// import stripeService from "@/modules/Stripe/service.js";
// import DateSelector from "@/components/DateSelector";

export default {
  props: {
    toggleStatus: {
      default: 'show',
    },
    CustomerId: {
      default: null,
    },
    DonorId: {
      default: null,
    },
    showAll: {
      default: false,
    },
    due: {
      default: false,
    },
  },
  name: "recurring-invoice-list",
  data() {
    return {
      selectedSubscription: null,
      createDialog: false,
      showExpire: false,
      selectedInvoiceParentPayDue: 0,
      loadingBtn: false,
      selectedCard: null,
      loadingCard: false,
      loadingDialog: false,
      showCustomersOnly: false,
      showDonorsOnly: false,
      toggleChange: '',
      dateTime: {
        start: this.$moment().startOf("day").toISOString(),
        end: this.$moment().endOf("day").toISOString(),
      },
      headers: [],
      Subscriptions: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "id",
      pageCount: 0,
      sortDesc: true,
      itemsPerPage: 10,
    };
  },
  components: {
    Create,
  },
  watch: {
    // DonorId: {
    //   immediate: true,
    //   handler() {
    //     this.getList();
    //   },
    // },
    toggleChange(val){
      if(val === 0){
        this.showDonorsOnly = true
        this.showCustomersOnly = false
      } else if(val === 1){
        this.showCustomersOnly = true
        this.showDonorsOnly = false
      } else {
        this.showCustomersOnly = false
        this.showDonorsOnly = false
      }
      this.getList()
    },
    showExpire(){
      this.getList()
    }
  },
  created() {
    this.loadHeader();
    this.getList()
    this.$events.listen("subscriptionListEvent", () => this.getList());
    // this.$events.listen("invoiceListEvent", () => this.getList());
    // document.title = "taleem - Invoice List";
  },
  beforeDestroy() {
    this.$events.remove("subscriptionListEvent");
  },
  computed: {
    ...mapGetters("global", [
      "currentUser",
      "checkRightStatus",
      "currentBusiness",
    ]),
    ...mapGetters("customer", ["getCustomer"]),
    ...mapGetters("subscription", ["InvoiceDetails", "getEditInvoiceId"]),
  },
  methods: {
    ...mapActions("subscription", ["ResetInvoice"]),
    runTest() {
      console.log('running')
      subscriptionService.createAutoInvoice().then((response) => {
        console.log('response', response)
      })
    },
    formattedNextInvoiceDate(nextInvoiceDate) {
      // console.log('sub.nextInvoiceDate', nextInvoiceDate)
      return moment.utc(nextInvoiceDate).format('MM/DD/YYYY');
    },
    isRecurringExpired(item) {
      if (item.endDate) {
        const endDate = new Date(item.endDate);
        const nextInvoiceDate = new Date(item.nextInvoiceDate);
        if (endDate < nextInvoiceDate) {
          // console.log('endDate > nextInvoiceDate', endDate > nextInvoiceDate, endDate, nextInvoiceDate)
        }

        return endDate > nextInvoiceDate; // Returns true if end date is greater than current date
      }
      return true
    },
    close() {
      this.reset()
      this.paymentDialog = false
    },
    async receivePayment(val) {
      this.selectedInvoice = (await subscriptionService.getById(val.id)).data
      let dueAmount = 0
      // this.selectedInvoiceParentPayDue = dueAmount
      this.selectedInvoice.InvoiceDetails.map(row => {
        console.log('rowrowrow', row)
        dueAmount += row.parentPay
      })
      if (dueAmount === 0) {
        this.Payment.amount = val.due
      } else {
        this.Payment.amount = dueAmount
      }
      this.selectedInvoiceParentPayDue = dueAmount
      this.paymentDialog = !this.paymentDialog
    },
    add() {
      // this.ResetInvoice();
      // this.$router.push({path: `/subscription/create`});
      if (this.DonorId) {
        this.$router.push({
          path: `/subscription/create?DonorId=${this.DonorId}`,
        });
      } else {
        this.$router.push({
          path: `/subscription/create?CustomerId=${this.getCustomer.id}`,
        });
      }
    },
    viewSubscription(subscription) {
      const hashId = hashids.encode(subscription.id);
      const routeData = this.$router.resolve({
        path: `/global/subscription/${hashId}/view`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    viewProfileNewTab(val) {
      let routeData = null
      if (val.DonorId) {
        routeData = this.$router.resolve({
          path: `/donors/${val.DonorId}/profile`,
        });
      } else {
        routeData = this.$router.resolve({
          path: `/parents/${val.CustomerId}/profile`,
        });
      }
      window.open(routeData.href, "_blank");
    },
    viewProfile(val) {
      if (val.DonorId) {
        this.$router.push({ path: `/donors/${val.DonorId}/profile` });
      } else {
        this.$router.push({ path: `/parents/${val.CustomerId}/profile` });
      }

    },
    loadHeader() {
      this.headers = [];
      // this.headers.push({
      //   text: 'ID',
      //   align: "left",
      //   value: "id",
      //   sortable: true,
      // });

      // this.headers.push({
      //   text: this.$t("labels.date"),
      //   align: "left",
      //   value: "date",
      //   sortable: true,
      // });

      // this.headers.push({
      //   text: "Starting Date",
      //   value: "startingDate",
      //   align: "left",
      //   sortable: true,
      // });


      this.headers.push({
        text: "Name",
        value: "name",
        align: "left",
        sortable: true,
      },
      {
        text: "",
        value: "",
        align: "left",
        sortable: true,
      });



      // if (this.DonorId) {
      //   this.headers.push({
      //     text: "Name",
      //     value: "Donor.name",
      //     align: "left",
      //     sortable: true,
      //   });
      // }
      // if (this.CustomerId) {
      //   this.headers.push({
      //     text: "Name",
      //     value: "Customer.name",
      //     align: "left",
      //     sortable: true,
      //   });
      // }



      this.headers.push({
        text: "Next Due Date",
        align: "left",
        value: "nextInvoiceDate",
        sortable: true
      });

      this.headers.push({
        text: "End Date",
        align: "left",
        value: "endDate",
        sortable: true
      });

      this.headers.push({
        text: "Total",
        value: "total",
        align: "right",
        sortable: true,
      });

      // this.headers.push({
      //   text: "Payment",
      //   value: "payment",
      //   align: "right",
      //   sortable: true,
      // });

      // this.headers.push({
      //   text: "Balance",
      //   value: "due",
      //   align: "right",
      //   sortable: true,
      // });
      this.headers.push({
        text: "",
        value: "action",
        sortable: false,
      });
    },
    getList() {
      this.loading = true;
      let where = {};
      // if (!this.showAll) {
      //   where = {
      //     start: this.dateTime.start,
      //     end: this.dateTime.end,
      //   };
      // }
      if (this.DonorId) {
        where.DonorId = this.DonorId;
      }

      if (this.CustomerId) {
        where.CustomerId = this.CustomerId;
      }

      if (this.due) {
        where.due = true;
      }
      where.showCustomersOnly = this.showCustomersOnly;
      where.showDonorsOnly = this.showDonorsOnly;
      where.showExpire = this.showExpire
      return subscriptionService.getAll(where).then((response) => {
        this.loading = false;
        this.Subscriptions = response.data;
        // console.log("response.data subscription ", response.data)
        this.Subscriptions.map(subscription => {
          let total = 0
          subscription.SubscriptionDetails.map(detail => {
            if (!detail.deletedAt)
              total += (detail.price * detail.qty)
          })
          subscription.total = total
          if(subscription.Customer)
            subscription.name = subscription.Customer.name
          else if(subscription.Donor)
            subscription.name = subscription.Donor.name
        })
        return response;
      });


    },
    createAutoInvoice() {
      return subscriptionService.createAutoInvoice().then((response) => {
        // this.Subscriptions = response.data;
        console.log('response', response)
        return response;
      });
    },
    editSubscription(subscription) {
      this.$router.push({ path: `/subscription/${subscription.id}/edit` });
    },
    createInvoice(subscription) {
      // console.log('subscription', subscription)
      this.loadingDialog = true
      return subscriptionService.createInvoice(subscription.id).then((response) => {
        // this.Subscriptions = response.data;
        // console.log('response', response)
        this.loadingDialog = false
        this.getList()
        this.$events.emit("invoiceListEvent");
        return response;
      }).catch(err => {
        this.loadingDialog = false;
        this.$swal({
          title: "Create Invoice",
          text: err.data.message,
          icon: "error",
        });
        console.log('error', err)
      })
    },
    createInvoiceAndCollect(subscription) {
      console.log('subscription', subscription)
      this.loadingDialog = true
      return subscriptionService.createInvoiceAndCollect(subscription.id).then((response) => {
        // this.Subscriptions = response.data;
        console.log('response', response)
        this.loadingDialog = false
        this.$events.emit("invoiceListEvent");
        return response;
      }).catch(err => {
        this.loadingDialog = false;
        this.$swal({
          title: "Create Invoice",
          text: err.data.message,
          icon: "error",
        });
        console.log('error', err)
      })
    },
    collectedPayment(subscription) {
      console.log('subscription', subscription)
      this.selectedSubscription = subscription
      this.createDialog = !this.createDialog
    },
    deleteSubscription(subscription) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.loadingDialog = true;
          subscriptionService
            .delete(subscription.id)
            .then((response) => {
              console.log("response delete", response);
              this.loadingDialog = false;
              if (response.data) {
                this.$swal
                  .mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                  })
                  .fire({
                    icon: "success",
                    title: "Subscription has been deleted.",
                  });
                this.getList();
              }
            })
            .catch((error) => {
              this.loadingDialog = false;
              this.$swal({
                title: "Delete Subscription",
                text: error.data.message,
                icon: "error",
              });
            });
        }
      });
    },
  },
};
</script>
